import { useState, useEffect } from "react";
import {
  AlertTriangle,
  Shield,
  ExternalLink,
  X,
} from "lucide-react";

export default function LegalDisclaimer({ onAccept }) {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem("betmodel_legal_accepted");
    if (stored === "true") {
      setAccepted(true);
      onAccept?.();
    }
  }, [onAccept]);

  const handleAccept = () => {
    sessionStorage.setItem("betmodel_legal_accepted", "true");
    setAccepted(true);
    onAccept?.();
  };

  if (accepted) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-xl">
      <div
        className="relative w-full max-w-lg mx-4 bg-surface border border-line rounded-md p-8 animate-slide-up"
        data-testid="legal-disclaimer-modal"
      >
        {/* 18+ Badge */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full border-4 border-danger flex items-center justify-center">
            <span className="font-heading text-3xl font-black text-danger">18+</span>
          </div>
        </div>

        <h2 className="font-heading text-2xl font-black text-center uppercase tracking-tight mb-4">
          Aviso Legal
        </h2>

        <div className="space-y-4 text-txt-secondary text-sm leading-relaxed">
          <div className="flex gap-3">
            <AlertTriangle className="w-5 h-5 text-warning shrink-0 mt-0.5" />
            <p>
              Esta aplicacao e <strong className="text-white">apenas para fins informativos</strong>. 
              As previsoes estatisticas nao garantem resultados e nao constituem aconselhamento financeiro.
            </p>
          </div>

          <div className="flex gap-3">
            <Shield className="w-5 h-5 text-volt shrink-0 mt-0.5" />
            <p>
              O jogo pode ser viciante. Aposte apenas o que pode perder. 
              Se tiver problemas com jogo, procure ajuda profissional.
            </p>
          </div>

          <div className="border border-line rounded-sm p-3 space-y-2">
            <p className="text-xs font-bold uppercase tracking-widest text-txt-secondary">
              Linhas de Ajuda
            </p>
            <a
              href="https://www.jogadorresponsavel.pt"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-azure hover:text-azure-hover transition-colors text-sm"
            >
              <ExternalLink className="w-3.5 h-3.5" />
              Jogador Responsavel (PT)
            </a>
            <a
              href="https://www.gamcare.org.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-azure hover:text-azure-hover transition-colors text-sm"
            >
              <ExternalLink className="w-3.5 h-3.5" />
              GamCare (UK)
            </a>
            <a
              href="https://www.begambleaware.org"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-azure hover:text-azure-hover transition-colors text-sm"
            >
              <ExternalLink className="w-3.5 h-3.5" />
              BeGambleAware
            </a>
          </div>
        </div>

        <button
          data-testid="legal-accept-btn"
          onClick={handleAccept}
          className="w-full mt-6 bg-volt text-volt-fg font-bold uppercase tracking-wide px-6 py-3.5 rounded-sm transition-all hover:bg-volt-hover active:scale-[0.98]"
        >
          Tenho 18+ anos e aceito os termos
        </button>
      </div>
    </div>
  );
}
